// Generated by scripts/write-build-revision.sh — do not commit.
export const GIT_REVISION = "a3e7d4e896914c4f4ff0f67e74fad1e6f6174701";
